import { faFile, faFileAlt, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { grey, lightGreen, orange, yellow } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de certidão.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_CERTIDAO = {
    NAO_CRIADA       : { id: 'NAO_CRIADA',       descricao: 'Não criada',      cor: grey[900]       },
    NAO_ASSINADA     : { id: 'NAO_ASSINADA',     descricao: 'Não assinada',    cor: orange[900]     },
    NAO_ASSINADA_SIJ : { id: 'NAO_ASSINADA_SIJ', descricao: 'Criada no SIJ',   cor: grey[900]       },
    ASSINADA         : { id: 'ASSINADA',         descricao: 'Assinada',        cor: lightGreen[900] },
    ASSINADA_SIJ     : { id: 'ASSINADA_SIJ',     descricao: 'Assinada no SIJ', cor: yellow[700]     }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de certidão.
 * @readonly
 */
class SituacaoCertidao {
    /**
     * @private
     * @static
     */
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_CERTIDAO);

    /**
     * Mensagem de erro para falha na identificação da situação da certidão.
     *
     * @public
     * @static
     */
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_CERTIDAO = 'Não foi possível identificar a situação da certidão.';

    /**
     * Retorna o ID da descrição da situação de certidão.
     *
     * @see {@link SituacaoIdDescricaoBase#getIdByDescricao}.
     */
    static getIdByDescricao(descricao) {
        return SituacaoCertidao.situacaoBase.getIdByDescricao(descricao);
    }

    /**
     * Retorna a descrição da situação de certidão correspondente ao ID.
     *
     * @see {@link SituacaoIdDescricaoBase#getDescricao}.
     */
    static getDescricao(id) {
        return SituacaoCertidao.situacaoBase.getDescricao(id);
    }

    /**
     * Retorna a cor da situação da certidão para textos e ícones.
     *
     * @param {string} id Identificador da situação de certidão.
     * @returns {string} O identificador de cor da situação de certidão correspondente ao ID.
     */
    static getCor(id) {
        return SituacaoCertidao.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getIcone(id, tamanhoIcone = '24px', cor = undefined) {
        let obj = SituacaoCertidao.situacaoBase.getObjectById(id);
        let iconeFA;

        switch (obj.id) {
            case SITUACAO_CERTIDAO.NAO_CRIADA.id:
                iconeFA = faFile;
                break;

            case SITUACAO_CERTIDAO.NAO_ASSINADA.id:
            case SITUACAO_CERTIDAO.NAO_ASSINADA_SIJ.id:
                iconeFA = faFileAlt;
                break;

            case SITUACAO_CERTIDAO.ASSINADA.id:
            case SITUACAO_CERTIDAO.ASSINADA_SIJ.id:
                iconeFA = faFileSignature;
                break;

            default:
                break;
        }

        if (!iconeFA) {
            return null;
        }

        return (
            <FontAwesomeIcon
                icon={iconeFA}
                style={{
                    width: tamanhoIcone,
                    height: tamanhoIcone,
                    color: cor ?? obj.cor,
                    fillOpacity: '0.7'
                }}
            />
        );
    }
}

export default SituacaoCertidao;
